export const Licenses = {
  MUI_X_PREMIUM_KEY:
    "8e40b69b6b984bc59b4a3db43f093f5bTz0xMDA3OTAsRT0xNzYxNzMzMzkxMDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y",
};
